export enum Layer2Code {
  LIGHTNING = 'LIGHTNING',
  ARBITRUM = 'ARBITRUM',
  POLYGON = 'POLYGON',
  OPTIMISM = 'OPTIMISM',
}
